import React, { useEffect } from "react";
import {
  Grid,
  Box, Skeleton
} from "@mui/material";
import StyledSection from "../../../common/StyledSection";
import { ContainedButton, TextButton } from "../../../common/StyledButtons";
import { withRouter } from "react-router";
import { getSiteById } from "../../../../selectors/SiteSelectors";


const GoogleDriveCard = ({ history, siteId }) => {

  const site = getSiteById(siteId);

  const renderResourcesCards = () => (
    <StyledSection
      title="Share a File"
      image="https://s3.us-east-2.amazonaws.com/docs.consultwithkyle.com/assets/share-files.webp"
    >
      <p>Need to send over files or share project assets? With BCK’s secure Google Drive integration, it’s simple to upload, organize, and collaborate, keeping your tasks and projects running seamlessly.</p>
      
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop: '40px'}}>
        <ContainedButton
          sx={{ padding: '8px 16px 8px 16px' }}
          onClick={() => window.open(site.site_external_connections.box.box_url, '_blank').focus()}
        >Access Drive</ContainedButton>
      </Box>
    </StyledSection>
  )

  if (site.site_external_connections.box) {
    return renderResourcesCards();
  }

  
}

export default withRouter(GoogleDriveCard);
